import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {limitOptionsSelect} from "../helps/optionsSelect"
import {asyncCreator} from "./sliceHelper"
import {psLeakDeviceLocalLogApi, PSLeakDeviceLocalLogsFilterQuery} from "../api/psLeakDeviceLocalLogApi"
import {WSPSLeakDeviceLocalLog} from "../types/WebSocketTypes"
import {PSLeakDeviceLocalLogResponse, PSLeakDeviceLocalLogsResponse} from "../models/response"

export type PSLeakDeviceLocalLogsFilter = {
    limit: number
    offset: number
} & PSLeakDeviceLocalLogsFilterQuery

type InitialStateType = {
    psLeakDeviceLocalLogs: null | PSLeakDeviceLocalLogsResponse
    psLeakDeviceLocalLog: null | PSLeakDeviceLocalLogResponse
    filter: PSLeakDeviceLocalLogsFilter
    ws: WSPSLeakDeviceLocalLog | null
}

const initialState: InitialStateType = {
    psLeakDeviceLocalLogs: null,
    psLeakDeviceLocalLog: null,
    filter: {
        limit: limitOptionsSelect[0].value,
        offset: 0,
    },
    ws: null,
}

export const psLeakDeviceLocalLogReducer = createSlice({
    name: 'psLeakDeviceLocalLogReducer',
    initialState,
    reducers: {
        setPSLeakDeviceLocalLogs(state, {payload}) {
            state.psLeakDeviceLocalLogs = payload
        },
        setPSLeakDeviceLocalLog(state, {payload}) {
            state.psLeakDeviceLocalLog = payload
        },
        editPSLeakDeviceLocalLog(state, {payload}: PayloadAction<PSLeakDeviceLocalLogResponse>) {
            let index = state.psLeakDeviceLocalLogs?.data.findIndex(i => i.id === payload.id)
            if (index !== undefined && state.psLeakDeviceLocalLogs) state.psLeakDeviceLocalLogs.data[index] = payload
            if (state.psLeakDeviceLocalLog) state.psLeakDeviceLocalLog = payload
        },
        setPSLeakDeviceLocalLogsFilter(state, {payload}) {
            state.filter = payload
        },
        setWSPSLeakDeviceLocalLog(state, {payload}: PayloadAction<WSPSLeakDeviceLocalLog | null>) {
            state.ws = payload
        },
    },
})

export const {setPSLeakDeviceLocalLogsFilter, setPSLeakDeviceLocalLogs, setPSLeakDeviceLocalLog, editPSLeakDeviceLocalLog, setWSPSLeakDeviceLocalLog} = psLeakDeviceLocalLogReducer.actions

export default psLeakDeviceLocalLogReducer.reducer

export const getPSLeakDeviceLocalLogs = asyncCreator
('psLeakDeviceLocalLogReducer/getPSLeakDeviceLocalLogs', psLeakDeviceLocalLogApi.getLogs, setPSLeakDeviceLocalLogs)

export const getPSLeakDeviceLocalLog = asyncCreator
('psLeakDeviceLocalLogReducer/getPSLeakDeviceLocalLog', psLeakDeviceLocalLogApi.getLog, setPSLeakDeviceLocalLog)

export const changePSLeakDeviceLocalLog = asyncCreator
('psLeakDeviceLocalLogReducer/changePSLeakDeviceLocalLog', psLeakDeviceLocalLogApi.updateLog, editPSLeakDeviceLocalLog)

export const solveArrayPSLeakDeviceLocalLogs = asyncCreator
('psLeakDeviceLocalLogReducer/solveArrayPSLeakDeviceLocalLogs', psLeakDeviceLocalLogApi.arraySolve)

export const deletePSLeakDeviceLocalLogs = asyncCreator
('psLeakDeviceLocalLogReducer/deletePSLeakDeviceLocalLogs', psLeakDeviceLocalLogApi.deleteAll)